<template>
  <div class="container">
    <!-- <h4>备课列表</h4> -->
    <div class="header" v-if="pagination.total > 0 || name">
      <a-input-search allowClear v-model="name" placeholder=" 请输入备课包名称" @change="onSearch">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="name" slot="suffix" @click="name = undefined, onSearch()" :src="require('@/assets/icons/icon_gb.png')" />
        <a-button class="search-btn" slot="enterButton">
          搜索
        </a-button>
      </a-input-search>
      <a-button type="primary" @click="prelessonAdd">新建备课</a-button>
    </div>
    <div class="list" v-if="pagination.total > 0">
      <div class="item" v-for="item in list" :key="item.key">
        <img class="icon-top" v-if="item.isTop" src="@/assets/img/bq_zd.png" alt="" srcset="">
        <img class="cover" v-if="item.cover" :src="item.cover" alt="" srcset="">
        <img class="cover" v-else src="@/assets/img/pic_kc@2x.png" alt="" srcset="">
        <div class="bottom">
          <a-tooltip class="left">
            <template slot="title">
              {{ item.name }}
            </template>
            {{ item.name }}
          </a-tooltip>
          <div class="right">
            <a-dropdown-button @click="edit(item.id)">
              <a-tooltip class="title">
                <template slot="title">
                  继续备课
                </template>
                <img
                  @mouseenter="editId = item.id"
                  @mouseleave="editId = -1"
                  :src="editId == item.id ? require('@/assets/img/icon_bj_x.png') : require('@/assets/img/icon_bj.png')">
              </a-tooltip>
              <a-menu slot="overlay">
                <a-menu-item @click="rename(item.id, item.name)">重命名</a-menu-item>
                <a-menu-item @click="copy(item.id)">复制</a-menu-item>
                <a-menu-item @click="toTop(item)">{{ item.isTop ? '取消置顶' : '置顶'}}</a-menu-item>
                <a-menu-item @click="delModal(item.id)">删除</a-menu-item>
              </a-menu>
            </a-dropdown-button>
          </div>
          <div class="time">{{ item.createdAt }}</div>
        </div>
      </div>
    </div>
    <div class="nodata" :class="{full: !name}" v-else>
      <img src="@/assets/img/bj_zanwushujv.png" alt="" srcset="">
      <div>
        <div>暂无备课数据</div>
        <a-button type="primary" v-if="!name" class="lesson-add" @click="prelessonAdd">新建备课</a-button>
        <div v-else>请换一个搜索词吧~</div>
      </div>
    </div>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <a-modal title="重命名备课信息" :visible="visible" @ok="ok" @cancel="visible = false">
      <span> * </span>备课名称：<a-input maxLength="15" allowClear v-model="replaceName" placeholder="请输入备课名称，最多支持15字" />
    </a-modal>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p></p>
        <p>确定要删除该备课？</p>
        <p class='placeholder'>备课数据删除后无法找回</p>`" />
  </div>
</template>
<script>
import {
  prepareLessonList,
  prepareLessonCopy,
  prepareLessonRename,
  prepareLessonSetTop,
  prepareLessonDelete
} from '@/api/lesson'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      editId: -1,
      name: undefined,
      visible: false,
      delId: undefined,
      delVisible: false,
      replaceName: undefined,
      list: [
        {
          id: 1,
          phase: '中职',
          name: '课程名称1',
          status: '已结束',
          top_status: true,
          courseLength: '01:30',
          end_time: '23-08-15 12:00',
          start_time: '23-08-15 10:30'
        },
        {
          id: 2,
          phase: '中职',
          name: '课程名称2',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 3,
          phase: '中职',
          name: '课程名称3',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 4,
          phase: '中职',
          name: '课程名称4',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 5,
          phase: '中职',
          name: '课程名称5',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 6,
          phase: '中职',
          name: '课程名称6',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        }
      ],
      columns: [
        {
          title: 'ID',
          key: 'id',
          dataIndex: 'id'
        },
        {
          title: '课程名称',
          key: 'name',
          dataIndex: 'name'
        },
        {
          title: '班级',
          key: 'phase',
          dataIndex: 'phase'
        },
        {
          title: '开课时间',
          key: 'start_time',
          dataIndex: 'start_time'
        },
        {
          title: '结束时间',
          key: 'end_time',
          dataIndex: 'end_time'
        },
        {
          title: '课程时长',
          key: 'courseLength',
          dataIndex: 'courseLength'
        },
        {
          title: '状态',
          key: 'status',
          dataIndex: 'status'
        },
        {
          title: '操作',
          key: 'operate',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      pagination: {
        page: 1,
        total: 0,
        pageSize: 15
      }
    }
  },
  methods: {
    onSearch() {
      this.pagination.page = 1
      this.getPrepareLessonList()
    },
    prelessonAdd() {
      localStorage.removeItem('prepareData')
      this.$router.push({
        name: 'prepareAdd'
      })
    },
    edit(id) {
      this.$router.push({
        name: 'prepareAdd',
        query: {
          id
        }
      })
    },
    rename(id, name) {
      this.visible = true
      this.replaceId = id
      this.replaceName = name
    },
    ok() {
      if (!this.replaceName) {
        this.$message.error('请输入备课名称！')
        return
      }
      prepareLessonRename({
        id: this.replaceId,
        name: this.replaceName
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('保存成功！')
          this.pagination.page = 1
          this.getPrepareLessonList()
          this.visible = false
        }
      })
      this.visible = false
    },
    copy(id) {
      prepareLessonCopy({ id }).then(res => {
        if (res.code == 200) {
          this.pagination.page = 1
          this.getPrepareLessonList()
          this.$message.success('复制成功！')
        }
      })
    },
    toTop(item) {
      prepareLessonSetTop({
        id: item.id,
        status: !item.isTop
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(item.isTop ? '取消置顶' : '已置顶')
          this.pagination.page = 1
          this.getPrepareLessonList()
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      prepareLessonDelete({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.$message.success('删除成功！')
          this.delVisible = false
          this.delId = undefined
          this.pagination.page = 1
          this.getPrepareLessonList()
        }
      })
    },
    handleTableChange() {
      this.getPrepareLessonList()
    },
    getPrepareLessonList() {
      const data = {
        name: this.name,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      prepareLessonList(data).then(res => {
        if (res.code != 200) return
        this.list = res.data.list
        this.pagination.total = res.data.total
      })
    }
  },
  mounted() {
    this.getPrepareLessonList()
  }
}
</script>

<style lang="less" scoped>
.container{
  position: relative;
  /deep/ .ant-table {
    min-height: 583px;
  }
  .list-pagination{
    width: 100%;
    height: auto;
    // bottom: 50px;
    position: absolute;
  }
}
h4{
  padding: 20px 28px 0 19px;
}
p{
  font-size: 12px;
  font-weight: 400;
  color: #687F9C;
  margin-bottom: 0;
  line-height: 17px;
  padding: 0 28px 0 19px;
}
.header{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 46px 28px 22px 19px;
  justify-content: space-between;
  /deep/.ant-input-group-wrapper{
    width: 330px;
    height: 35px;
    .ant-input-prefix{
      // right: auto;
      left: 16px;
      img{
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon{
        display: none;
      }
      .clear{
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search{
      height: 35px;
      .ant-input{
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #D8DCE0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn{
      border-left: 0;
      height: 35px;
      border-color: #D8DCE0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span{
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        align-items: center;
        &::before{
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #E9E9E9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
}
.list{
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  padding: 12px 28px 0 19px;
  max-height: calc(100% - 150px);
  .item{
    width: calc((100% - 88px) / 5);
    margin-top: 18px;
    margin-right: 22px;
    position: relative;
    display: inline-block;
    .icon-top{
      top: 6px;
      left: 0;
      width: 59px;
      height: 26px;
      position: absolute;
    }
    .cover{
      width: 100%;
      height: 172px;
      cursor: pointer;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .bottom{
      display: flex;
      flex-wrap: wrap;
      cursor: pointer;
      padding: 12px 0px 12px 4px;
      align-items: flex-start;
      justify-content: space-between;
      .left{
        color: #000;
        font-weight: 550;
        overflow: hidden;
        text-wrap: nowrap;
        margin-bottom: 2px;
        display: inline-block;
        text-overflow: ellipsis;
        width: calc(100% - 80px);
      }
      .right{
        margin-top: 2px;
        /deep/.ant-btn-group {
          display: flex;
          align-items: center;
          .ant-btn{
            height: 21px;
            display: flex;
            padding-right: 12px;
            align-items: center;
            &:last-child{
              padding-right: 3px;
              padding-left: 3px;
              border-radius: 2px;
            }
          }
        }
        img{
          width: 16px;
          height: 16px;
        }
      }
        .time{
          width: 100%;
          color: #666666;
          font-size: 12px;
        }
    }
    &:nth-child(-n + 5) {
      margin-top: 0;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
  /deep/.ant-btn-default,
  .ant-dropdown-trigger{
    border: 0;
    color: #000000;
    box-shadow: none;
    border: 1px solid #fff;
  }
  /deep/.ant-dropdown-trigger.ant-dropdown-open{
    color: #FF6D00;
    background: #FFEDEA;
    border: 1px solid #FF6D00;
  }
}
.list::-webkit-scrollbar{
  display: none;
}

/deep/.ant-modal{
  .ant-modal-body{
    color: #000;
    font-size: 14px;
    span:first-child{
      color: red;
      margin-right: 6px;
    }
    .ant-input-affix-wrapper{
      // width: 300px;
      margin-top: 6px;
      .ant-input{
        color: #000;
      }
    }
  }
  .ant-modal-footer{
    text-align: center;
    .ant-btn-primary{
      margin-left: 50px;
    }
  }
}
.nodata{
  display: flex;
  position: relative;
  align-items: center;
  padding: 150px 100px;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 103px);
  img{
    width: 285px;
    // height: 300px;
    margin-bottom: 20px;
  }
  >div{
    width: 100%;
    display: flex;
    margin-top: -70px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    div{
      color: #0D2340;
      cursor: pointer;
      font-weight: 550;
      margin-left: 10px;
      font-size: 14px;
      position: relative;
      &:last-child{
        font-weight: 500;
        font-size: 12px;
      }
    }
    .lesson-add{
      cursor: pointer;
      font-weight: 500;
      margin-left: 10px;
      margin-top: 12px;
    }
  }
}
.full.nodata{
  height: 100%;
}
.item:hover{
  .bottom .left{
    color: #FF6D00 !important;
  }
}
/deep/.ant-dropdown-menu-item{
  text-align: center;
  &:hover{
    color: #FF6D00;
    background: none;
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px){
  .list{
    .item{
      .cover{
        height: 154px;
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px){
  .list{
    .item{
      .cover{
        height: 127px;
      }
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px){
  .list{
    .item{
      .cover{
        height: 127px;
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px){
  .list{
    .item{
      .cover{
        height: 112px;
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px){
  .list{
    .item{
      .cover{
        height: 107px;
      }
    }
  }
}
@media screen and (max-width: 1200px){
  .list{
    .item{
      .cover{
        height: 79px;
      }
    }
  }
}
</style>
